import React from 'react';
import MoneyInput from 'components/MoneyInput';
import { formatCents } from 'utils/rateSettings/SharedRateSettingsForm.utils';
import { deriveInheritedRatePreview } from '../rateController/rateControllerModel';

type Props = {
  source: string;
  inheritedSettings?: any;
};

export const BlendedRateCentsInput = ({ source, inheritedSettings = {} }: Props) => {
  const inheritedBlended = deriveInheritedRatePreview({
    inherited: inheritedSettings,
    source,
    isLocationLevel: false,
  }).blendedRateCents;

  return (
    <MoneyInput
      source={`${source}.blended_rate_cents`}
      label="12hr Charge Rate"
      disabled
      helperText={formatCents(inheritedBlended)}
    />
  );
};
